import { buildApiUrl, Type } from "@/api/api";
import { InvoiceStatusNumeric, ChargeType } from '@/features/invoices/constants'

export { InvoiceStatusNumeric as InvoiceStatus, ChargeType }

export const invoiceStatusAsList = () => [
  { status: InvoiceStatusNumeric.ActionRequired, displayName: 'Action Required' },
  { status: InvoiceStatusNumeric.Approved, displayName: 'Approved' },
  { status: InvoiceStatusNumeric.Cancelled, displayName: 'Cancelled' },
  { status: InvoiceStatusNumeric.Draft, displayName: 'Draft' },
  { status: InvoiceStatusNumeric.Paid, displayName: 'Paid' },
  { status: InvoiceStatusNumeric.Sent, displayName: 'Sent' },
]


export const Urls = {
  exportInvoices: buildApiUrl(Type.AssetManagement, 'billing/invoices/exports').toString(),
} as const

export enum ExportPowerEscalationType {
  Currency = 1,
  Percentage = 2
}

export enum Measure {
  ForwardActiveEnergy,
  ReverseActiveEnergy
}

export enum TariffStructureType {
  FixedHourly = 1,
  FixedWinterSummer = 2,
  TimeOfUse = 3,
  FixedMonthly = 4
}

export enum DisplayOptions {
  Hide = 0,
  Show = 1
}